// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-calendar-container {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.select-calendar-container h2 {
    font-size: 36px;
    color: #333;
    font-weight: 500;
}

.select-calendar-container button {
    margin-bottom: 6px;
    padding: 8px 16px;
}

.calendar-options {
    margin-top: 32px;
    display: flex;
    justify-content: space-around;
    width: 100%;
    max-width: 900px;
    margin-bottom: 40px;
}

.calendar-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
    height: 210px;
    margin: 23px 23px 0 23px;
    border: 2px solid #000;
    border-radius: 30px;
    background-color: #fff;
    cursor: pointer;
    transition: background-color 0.3s;
}

.calendar-button:hover {
    background-color: #e0e0e0;
}

.calendar-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
} 

.calendar-option span {
  font-size: 26px;
  color: #333;
} 
`, "",{"version":3,"sources":["webpack://./src/screens/add-events/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".select-calendar-container {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.select-calendar-container h2 {\n    font-size: 36px;\n    color: #333;\n    font-weight: 500;\n}\n\n.select-calendar-container button {\n    margin-bottom: 6px;\n    padding: 8px 16px;\n}\n\n.calendar-options {\n    margin-top: 32px;\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n    max-width: 900px;\n    margin-bottom: 40px;\n}\n\n.calendar-button {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 250px;\n    height: 210px;\n    margin: 23px 23px 0 23px;\n    border: 2px solid #000;\n    border-radius: 30px;\n    background-color: #fff;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.calendar-button:hover {\n    background-color: #e0e0e0;\n}\n\n.calendar-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n} \n\n.calendar-option span {\n  font-size: 26px;\n  color: #333;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
